import withAuth from "../../components/auth";
import { injectIntl } from "react-intl";

function RegisteredCalls() {
  return (
    <>
      <registered-calls />
    </>
  );
}

export default injectIntl(withAuth(RegisteredCalls));
